$(document).ready(function() {

  // Chrome...
  if ( navigator.userAgent.indexOf('Chrome') != -1 ) {
      $('body').addClass('chrome');
  }
  
  // Firefox...
  if ( navigator.userAgent.indexOf('Firefox') != -1 ) {
      $('body').addClass('firefox');
  }
  
  // Safari...
  if ( navigator.userAgent.indexOf('Safari') != -1 ) {
      $('body').addClass('safari');
  }
  
  // Edge...
  if ( navigator.userAgent.match(/Edge/) ) {
      $('body').addClass('edge');
  }

  // Arch carousel...
  $('.arch-carousel__slider').rotatingSlider({
    slideHeight: Math.min(360, window.innerWidth -80),
    slideWidth: Math.min(480, window.innerWidth - 80)
  });
    
  // Testimonial carousel
  $('.testimonial-carousel__slider').flickity({
    cellAlign: 'left',
    prevNextButtons: false,
    pageDots: false,
    groupCells: true,
    wrapAround: true
  });

  // If testimonial carousel is active...
  if ( $('.testimonial-carousel__slider').length > 0 ) {

    // Get flickerty instance for testimonial carousel...
    var flkty = $('.testimonial-carousel__slider').data('flickity');
  
    // Progress bar for testimonial carousel...
    flkty.on('scroll', function(progress) {
      progress = Math.max(0, Math.min(1, progress));
      $('.testimonial-carousel__progress-bar span.track').css('width', (progress * 100) + '%');
    });
  
    // Previous button...
    $('.testimonial-carousel__arrow-btns span.arrow.left').on('click', function() {
      var carousel = $('.testimonial-carousel__slider').flickity();
      carousel.flickity('previous');
    });
    
    // Next button...
    $('.testimonial-carousel__arrow-btns span.arrow.right').on('click', function() {
      var carousel = $('.testimonial-carousel__slider').flickity();
      carousel.flickity('next');
    });
  

  }

  var product_slider_initialized = false;
  function initialize_product_slider() {
    // Check if the window width is 600px or less...
    if ( $(window).width() <= 600 && !product_slider_initialized ) {
      $('.product-images').flickity({
        cellAlign: 'left',
        prevNextButtons: false,
        pageDots: false
        //pageDots: true
      });
      product_slider_initialized = true;
    } else if ( $(window).width() > 768 && product_slider_initialized ) {
      // Destroy product slider if screen is larger than 600px...
      $('.product-images').flickity('destroy');
      product_slider_initialized = false;
    }
  }

  // Initialize on page load...
  initialize_product_slider();

  // Reinitialize on window resize...
  $(window).on('resize', function () {
    initialize_product_slider();
  });

  $('.product-images').on( 'change.flickity', function(event, index) {
    $('.product-thumbnails .thumbnail-trigger').removeClass('active');
    $('.product-thumbnails .thumbnail-trigger[data-slide="' + index + '"]').addClass('active');
  });

  $('.product-thumbnails .thumbnail-trigger').click(function() {
    var index = $(this).data('slide');
    var product_images = $('.product-images').flickity();
    product_images.flickity('select', index); 
  });

  // Get cart...   
  function get_cart() {
    $.ajax({
      type: 'GET',
      url: '/cart',
      dataType: 'json',
      success: function(cart) {
        if ( cart.item_count > 0 ) {
          $('.cart-icon').addClass('visible');
        } else {
          $('.cart-icon').removeClass('visible');
        }
      }
    });
  }
  get_cart();

  // Check for cart updates...
  document.addEventListener('cart:change', get_cart);
  document.addEventListener('cart:refresh', get_cart);
  document.addEventListener('variant:add', get_cart);

  // Select the header wrapper element...
  const headerElement = document.querySelector('header .header__wrapper');
  
  // Select all <details> elements within the menu...
  const detailsElements = document.querySelectorAll('header .header__main-nav .header__link-list ul li details');
  
  // Function to check if any <details> element is open...
  function updateMegaMenuClass() {
    const isAnyMenuOpen = Array.from(detailsElements).some(details => details.hasAttribute('open'));
    if (isAnyMenuOpen) {
      headerElement.classList.add('mega-menu-active');
    } else {
      headerElement.classList.remove('mega-menu-active');
    }
  }
  
  // Create a MutationObserver to observe each <details> element...
  const observer = new MutationObserver(updateMegaMenuClass);
  
  // Define the configuration for the observer...
  const config = { attributes: true, attributeFilter: ['open'] };
  
  // Start observing each <details> element...
  detailsElements.forEach(details => observer.observe(details, config));
  
  // Initial check to set the class based on the current state of <details> elements...
  updateMegaMenuClass();

  // Toggle read more...
  $('.read-more').click(function(e) {
    e.preventDefault();
      var read_more_text = $(this).text();
      $(this).text(read_more_text == 'Read More' ? 'Read Less' : 'Read More');
      $(this).prev('div.prose').toggleClass('has-clamp');
  });

  // // Match column heights of blog card info...
  $('.blog-post-card .blog-post-card__info').matchHeight({
      byRow: true,
      property: 'min-height'
  });

  // Match column heights of stacking cards...
  $('.stacking-cards .columns .column .cards .card .card__text').matchHeight({
      byRow: true,
      property: 'min-height'
  });

  // Get external links...
  function get_external_links() {
    if ( $('#external-links').length ) {
      var link_url = '';
      var link_text = '';
      var external_links_data = JSON.parse($('#external-links').html());
      if ( external_links_data.links.length > 0 ) {
        $.each(external_links_data.links, function(index, value) {
          if ( value.currency == selected_currency ) {
            var external_btn = $('.product-info__buy-buttons').find('a.external-btn');
            external_btn.attr('href', value.link_url).text(value.link_text);
          }
        });
        $('.product-info__buy-buttons').addClass('show-external-btn');
      }
    }
  }

  // Check to see if the user is viewing a product page...
  if ( typeof(window.meta.product) !== 'undefined' ) {
    
    // Show external button...
    // if ( selected_currency !== 'GBP' ) {
    get_external_links();
    // } else {
    //   $('.product-info__buy-buttons').addClass('show-form');
    // }
    
  }
  
});